export function zeroFilling(data, options) {
    const { factor = 2, digitalFilterValue: grpdly = 0 } = options;
    const nbPoints = options.nbPoints || 2 ** Math.round(Math.log2(data.re.length * factor));
    let pointsToShift;
    if (grpdly > 0) {
        pointsToShift = Math.floor(grpdly);
    }
    else {
        pointsToShift = 0;
    }
    const { re, im } = data;
    const newRE = new Float64Array(nbPoints);
    const newIM = new Float64Array(nbPoints);
    const length = Math.min(nbPoints, re.length);
    newRE.set(re.slice(0, length - pointsToShift));
    newIM.set(im.slice(0, length - pointsToShift));
    if (pointsToShift > 0 && pointsToShift < nbPoints) {
        newRE.set(re.slice(re.length - pointsToShift), nbPoints - pointsToShift);
        newIM.set(im.slice(re.length - pointsToShift), nbPoints - pointsToShift);
    }
    return { re: newRE, im: newIM };
}
//# sourceMappingURL=zeroFilling.js.map